<template>
   <div class="  is-fullheight sticky-sidebar" >
     <aside class="menu column  aside   is-fullheight" >
      <p class="menu-label">
        Reports
      </p>
      <ul class="menu-list">
        <li>
          <a class="">Management</a>
          <ul>
            <li @click="activeMenuLink = '/reports/early-orders'"><router-link to="/reports/early-orders"  :class="{'is-active':activeMenuLink === '/reports/early-orders'}">Early Orders</router-link></li>
             <li @click="activeMenuLink = '/reports/orders-with-kids'"><router-link to="/reports/orders-with-kids"  :class="{'is-active':activeMenuLink === '/reports/orders-with-kids'}">Orders With Kids Sizes</router-link></li>
             <li @click="activeMenuLink = '/reports/printing-throughput-report'"><router-link to="/reports/printing-throughput-report"  :class="{'is-active':activeMenuLink === '/reports/printing-throughput-report'}">Printed Throughput Report</router-link></li>
          </ul>
        </li>
        
        
        
      </ul>

      <ul class="menu-list">
        <li>
          <a class="">Orders</a>
          <ul>
            <li @click="activeMenuLink = '/reports/account-orders'"><router-link to="/reports/account-orders"  :class="{'is-active':activeMenuLink === '/reports/account-orders'}">Orders Within Dates</router-link></li>
            <li @click="activeMenuLink = '/reports/orders-short-delivery'"><router-link to="/reports/orders-short-delivery"  :class="{'is-active':activeMenuLink === '/reports/orders-short-delivery'}">Orders With Short Delivery</router-link></li>
            <li @click="activeMenuLink = '/reports/garment-report'"><router-link to="/reports/garment-report"  :class="{'is-active':activeMenuLink === '/reports/garment-report'}">Garment Report</router-link></li>
             <li @click="activeMenuLink = '/reports/aggregated-sock-orders'"><router-link to="/reports/aggregated-sock-orders"  :class="{'is-active':activeMenuLink === '/reports/aggregated-sock-orders'}">Aggregated Sock Orders</router-link></li>
          </ul>
        </li>
        
        
        
      </ul>

      <ul class="menu-list">
        <li>
          <a class="">Designs</a>
          <ul>
            <li @click="activeMenuLink = '/reports/designs-uploaded'"><router-link to="/reports/designs-uploaded"  :class="{'is-active':activeMenuLink === '/reports/designs-uploaded'}">Designs Uploaded</router-link></li>
            
          </ul>
        </li>
        
        
        
      </ul>
      
    </aside>
    
   </div>
</template>

<script>
export default {
  name: 'SideBarReports',
  components: {
  },
  data() {
    return { activeMenuLink: null }
  },
  mounted() {
    //this.activeMenuLink = this.$route.path.substring(1)
    this.activeMenuLink = this.$route.path
    console.log(this.activeMenuLink)
  }
}

</script>



